import "./CloseButtonModal.css"
const CloseButtonModal = props => {
    return <button className={"close-modal"} onClick={props.onClickClosePopupBloem}>X</button>
}
export default CloseButtonModal